import { Component } from '@angular/core';

@Component({
  selector: 'mpp-res-med-label',
  templateUrl: './res-med-label.component.html',
  styleUrls: ['./res-med-label.component.scss'],
  standalone: false,
})
export class ResMedLabelComponent {}
